import authGuard from '@/router/auth-guard'

import { authFeatureGuard } from '@/router/auth-feature-guard'

export default [
  {
    path: '/communications',
    name: 'communications',
    component: () =>
      import(
        /* webpackChunkName: "communications" */ '@/pages/Management/mailingCommunications/List.vue'
      ),
    beforeEnter: authGuard
  },
  {
    path: '/communicationtabs/:id',
    name: 'communicationtabs',
    component: () =>
      import(
        /* webpackChunkName: "communications" */ '@/pages/Shared/mailingCommunications/details/index.vue'
      ),
    beforeEnter: authFeatureGuard(15),
    children: [
      {
        path: 'communicationGeneralInfo',
        name: 'communication.communicationGeneralInfo',
        component: () =>
          import(
            /* webpackChunkName: "communications" */ '@/pages/Shared/mailingCommunications/details/tabs/generalInfo/index.vue'
          )
      },
      {
        path: 'communicationScheduling',
        name: 'communication.communicationScheduling',
        component: () =>
          import(
            /* webpackChunkName: "communications" */ '@/pages/Shared/mailingCommunications/details/tabs/scheduling/index.vue'
          )
      },
      {
        path: 'communicationAudiences',
        name: 'communication.communicationAudiences',
        component: () =>
          import(
            /* webpackChunkName: "communications" */ '@/pages/Shared/mailingCommunications/details/tabs/audiences/index.vue'
          )
      },
      {
        path: 'composeMail',
        name: 'communication.composeMail',
        component: () =>
          import(
            /* webpackChunkName: "communications" */ '@/pages/Shared/mailingCommunications/details/tabs/composeMail/index.vue'
          )
      },
      {
        path: 'composeEmail',
        name: 'communication.composeEmail',
        component: () =>
          import(
            /* webpackChunkName: "communications" */ '@/pages/Shared/mailingCommunications/details/tabs/composeEmail/index.vue'
          )
      },
      {
        path: 'composeSms',
        name: 'communication.composeSms',
        component: () =>
          import(
            /* webpackChunkName: "communications" */ '@/pages/Shared/mailingCommunications/details/tabs/composeSms/index.vue'
          )
      },
      {
        path: 'communicationAttachments',
        name: 'communication.attachments',
        component: () =>
          import(
            /* webpackChunkName: "communications" */ '@/pages/Shared/mailingCommunications/details/tabs/attachments/index.vue'
          )
      },
      {
        path: 'communicationReview',
        name: 'communication.review',
        component: () =>
          import(
            /* webpackChunkName: "communications" */ '@/pages/Shared/mailingCommunications/details/tabs/review/index.vue'
          )
      },
      {
        // If no tab is specifed, go to overview
        path: '',
        redirect: 'communications'
      },
      {
        // If path doesn't match, go to overview
        path: '*',
        redirect: 'communications'
      }
    ]
  }
]
